@mixin category-styles {
  border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
  color: var(--cxsShell_MenuTextColor);
  font: var(--cxsShell_MenuHeadingFont);

  ds-icon {
    margin-inline-start: var(--cxs-spacer-xs);
  }
}

.submenu-row {
  display: flex;
  column-gap: var(--cxs-spacer-xl);

  &--explore {
    justify-content: center;
    column-gap: var(--cxs-spacer-xxl);
  }

  &--adjustable {
    column-gap: var(--adjustable-padding);
  }

  &__column {
    display: flex;
    flex-direction: column;
    width: var(--submenu-width);
  }

  &__category {
    @include category-styles();
    margin-block: none calc(var(--cxs-spacer-s) / 2);

    .link,
    &-text {
      padding-block-end: var(--cxs-spacer-s);
    }

  }

  &__category-text {
    margin: 0;
  }

  &__links {
    margin: 0;
    padding: 0;
  }

  &__link {
    font: var(--cxsShell_MenuFont);
    list-style: none;

    .link {
      padding-block: calc(var(--cxs-spacer-s) / 2);
    }

    &--category {
      @include category-styles();

      &:first-child .link {
        padding-block: calc(var(--cxs-spacer-m) + calc(var(--cxs-spacer-s) / 2)) var(--cxs-spacer-s);
      }

      &:not(:first-child) .link {
        padding-block: var(--cxs-spacer-l) var(--cxs-spacer-s);
      }
    }

    &:hover {
      ds-icon {
        --ds-icon-color: inherit;
      }
    }
  }

  &__divider {
    width: calc(var(--submenu-width) / 3);
    margin-block: calc(var(--cxs-spacer-s) / 2);
    margin-inline: 0;
    border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
  }

  &__ceo-paragraph {
    margin: 0;
  }

  &__external-label {
    position: absolute;
    inset-inline-start: -9000px;
    width: 0;
    overflow: hidden;
  }

  &__external-icon {
    --ds-icon-width: #{rem(.875)};
    --ds-icon-color: var(--cxsShell_MenuIconColor);
    margin-inline-start: var(--cxs-spacer-xs);
  }
}

[data-mode='light'] {
  .submenu-row {
    &--explore {
      column-gap: rem(3.25);
    }

    &__link .link {
      padding-block: rem(.5) rem(.5);
      padding-inline: rem(.5) rem(.75);
      display: block;
    }

    &__category,
    &__link--category {
      --button-width: 100%;
      margin-block-end: rem(.75);

      .link,
      &-text {
        display: flex;
        box-sizing: border-box;
        padding-block: rem(.5) rem(.75);
        padding-inline: rem(.5) rem(.75);
      }

      ds-icon {
        --ds-icon-width: #{rem(.875)};
        margin-inline-start: auto;
      }
    }

    &__external-icon {
      display: inline-block;
      margin-inline-start: rem(.25);
      vertical-align: middle;
    }
  }
}
